import { cx } from '@emotion/css';
import type { PropsWithChildren } from 'react';
import Scrollbars from 'components/scroll/Scrollbars';
import './layout.css';

export type CenteredPageProps = {
  className?: string | undefined;
};

const CenteredBlock = ({ children, className }: PropsWithChildren<CenteredPageProps>) => (
  <div className="wrap">
    <div className="overlay">
      <div className={cx('conciseWindow', className)}>{children}</div>
    </div>
  </div>
);

export const CenteredPage = ({ children, className }: PropsWithChildren<CenteredPageProps>) => (
  <Scrollbars>
    <CenteredBlock className={className}>{children}</CenteredBlock>
  </Scrollbars>
);
export { CenteredBlock };
export default CenteredPage;
